module.exports = {
  emptyMessage: 'กรุณากรอกชื่อตามที่ปรากฏบนบัตร',
  containsNumberMessage: 'ชื่อไม่สามารถมีตัวเลขได้',
  maxLengthMessage: 'อุ๊ปส์! คุณกรอกเกินจำนวนตัวอักษรที่อนุญาต กรุณากรอกใหม่',
  defaultMessage: 'อุ๊ปส์! ชื่อนี้ไม่ถูกต้อง',
};
